/* eslint-disable @typescript-eslint/no-explicit-any */

import { TFunction } from 'i18next';
import { TPartnerConfigurationDetails } from 'typings/partner';
import { DEFAULT_TRANSLATIONS } from '../../utils/translationFunctions';

// Create a function that returns the config and accepts an optional translation function
export const getNewaieyeConfig = (
  t?: TFunction
): TPartnerConfigurationDetails => {
  // Use either the passed translation function or default to build-time values
  const translations = DEFAULT_TRANSLATIONS.newaieye;

  // Handle translation with fallbacks to build-time defaults
  const translate = (
    key: string,
    options?: object,
    fallback?: string
  ): string => {
    if (t) {
      try {
        const translation = t(key, options as any);
        return translation !== key
          ? translation
          : fallback || translations[key as keyof typeof translations] || key;
      } catch (error) {
        console.warn(`Translation failed for key: ${key}`, error);
        return (
          fallback || translations[key as keyof typeof translations] || key
        );
      }
    }
    return translations[key as keyof typeof translations] || fallback || key;
  };

  return {
    nameOfCompany: 'newAIEye',
    typeOfCompany: 'Inc.',
    singinLabel: translate('signIn', undefined, 'Sign In') as string,
    welcomeText: translate(
      'welcomeText',
      {
        partnerName: 'NewAIEye'
      },
      'Welcome to NewAIEye'
    ) as string,
    label: 'NewAIEye',
    supportEmail: 'support@newaieye.co',
    supportEmail2: 'support@newaieye.co',
    phoneNumber: '+1 (220) 766-4660',
    companyAddress: '11948 S Cottage View Ln, Draper, UT 84020',
    updateDeteOfPrivacyPolicy: 'July 09, 2024',
    updateDeteOfTermsOfService: 'July 10, 2024',

    // todo: to update
    iosAppLink: 'https://apps.apple.com/app/id6779105264',
    androidAppLink:
      'https://play.google.com/store/apps/details?id=co.newaieye.homesecurity'
  };
};

// Export a static config for bundling/tree-shaking
const newaieyeConfig = getNewaieyeConfig();
export default newaieyeConfig;
